import React, { useState, useEffect } from 'react';
import { Menu, X, Download } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'https://customer-assets.emergentagent.com/job_744874e0-0fe3-4cd2-a918-10824da88281/artifacts/7oog39co_Sperah_Full_Combined_Presentation_Final.pptx';
    link.download = 'Sperah_Project_Management_Presentation.pptx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const navLinks = [
    { name: 'Home', id: 'home' },
    { name: 'About', id: 'about' },
    { name: 'Services', id: 'services' },
    { name: 'Methodology', id: 'methodology' },
    { name: 'Contact', id: 'contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-lg shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <div className="text-2xl font-bold">
              <span className="text-[#8B2635]">SPERAH</span>
              <span className={`ml-2 text-sm ${isScrolled ? 'text-gray-700' : 'text-gray-600'}`}>
                PROJECT MANAGEMENT
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`text-sm font-medium transition-colors duration-300 hover:text-[#8B2635] ${
                  isScrolled ? 'text-gray-700' : 'text-gray-800'
                }`}
              >
                {link.name}
              </button>
            ))}
            <Button
              onClick={handleDownload}
              className="bg-gradient-to-r from-[#8B2635] to-[#A63446] hover:from-[#A63446] hover:to-[#8B2635] text-white transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <Download className="mr-2 h-4 w-4" />
              Download PPTX
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-[#8B2635] transition-colors"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-lg shadow-lg">
          <div className="px-4 pt-2 pb-4 space-y-2">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left px-4 py-3 text-gray-700 hover:bg-gray-100 hover:text-[#8B2635] rounded-lg transition-colors"
              >
                {link.name}
              </button>
            ))}
            <Button
              onClick={handleDownload}
              className="w-full bg-gradient-to-r from-[#8B2635] to-[#A63446] hover:from-[#A63446] hover:to-[#8B2635] text-white"
            >
              <Download className="mr-2 h-4 w-4" />
              Download PPTX
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;